"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadI18Next = exports.ELanguageKey = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var ELanguageKey;
(function (ELanguageKey) {
    ELanguageKey["de"] = "de";
    ELanguageKey["en"] = "en";
})(ELanguageKey = exports.ELanguageKey || (exports.ELanguageKey = {}));
exports.loadI18Next = function (languages) {
    var _a;
    i18next_1.default.use(react_i18next_1.initReactI18next).init({
        resources: (_a = {},
            _a[ELanguageKey.de] = {
                translation: languages[ELanguageKey.de],
            },
            _a[ELanguageKey.en] = {
                translation: languages[ELanguageKey.en],
            },
            _a),
        lng: ELanguageKey.de,
        fallbackLng: ELanguageKey.en,
        interpolation: {
            escapeValue: false,
        },
        nsSeparator: ':::',
        keySeparator: '::',
        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
        },
    });
};
//# sourceMappingURL=i18n.js.map